<template>
  <div id="app">
    <div class="content">
      <el-row type="flex" align="middle" class="row">
        <el-col :span="4">
          <router-link to="/PC/">
            <div>
              <img src="/static/logo.png" alt="" />
            </div>
          </router-link>
        </el-col>
        <el-col :span="20">
          <!-- 搜索框第一行 -->
          <el-row>
            <el-col :span="12" :push="1">
              <el-row>
                <el-col>
                  <div style="margin-top: 4px" @keyup.enter="search()">
                    <el-autocomplete v-model="searchData" :fetch-suggestions="querySearch" placeholder="请输入内容" :trigger-on-focus="true" @select="handleSelect" style="display: block">
                      <el-button slot="append" icon="el-icon-search" @click="search()" ></el-button>
                      <el-button slot="append" type="danger" icon="el-icon-delete" plain style="margin-left: -90px;" @click="clear()"></el-button>
                    </el-autocomplete>
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="0" type="flex"justify="space-between" style="margin-top: 4px;float: right;">
                <el-col>
                  <el-link v-if="restaurants.length>0" :underline="false" @click="clearhistory()">清除历史记录</el-link>
                </el-col>
              </el-row>
            </el-col>
            <!-- 购物车 -->
            <el-col :span="4" :push="2" style="margin-top: 4px">
              <router-link to="/PC/cart">
              <!-- :max="99" {{ cartTotal > 0 ? cartTotal : cartTotal_}} -->
                <el-badge class="item" :value="cartTotal_">
                  <el-button icon="el-icon-shopping-cart-full" size="medium"> 我的购物车</el-button>
                </el-badge>
              </router-link>
            </el-col>
            <!-- /购物车 -->
          </el-row>
          <!-- /搜索栏第一行 -->
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { getHistorylist,clearhistory } from '@/api/history/history';
import { getCartInfo } from '@/api/cart/cart';

export default {
  name: 'Search',
  // props:['cartTotal'],
  watch: {
    '$store.getters.cartNum'(newVal,oldVal){
        this.cartTotal_ = newVal
    },
  },
  data() {
    return {
      searchData: this.$route.query.keyword == undefined ? '' :this.$route.query.keyword,
      restaurants: [],
      goodlist: [],
      categoryId: '',
      history: [],
      cartTotal_: 0
    };
  },
  computed: {
    getCartsLength() {
      if (this.$store.state.userInfo === null) {
        return 0;
      } else {
        console.log (this.$store.state.userInfo);
        return this.$store.state.userInfo.carts.length || 0;
      }
    },
  },
  methods: {
    getHistory(){
      getHistorylist().then(res=>{
        if(res.errno == 0){
          let arrray = new Array;
          var elem;
          this.history = res.data.historyKeywordList;
          this.history.forEach(element => {
            elem = { value : element.keyword };
            arrray.push(elem);
          });
          this.history = arrray.reverse();
        }
        this.restaurants = this.history;
      });
    },
    clearhistory(){
      clearhistory().then(res=>{
        if(res.errno == 0){
          this.history = '';
          this.restaurants = [];
          this.searchData = '';
          // this.clear();
        }
      });
    },
    search() {
      // this.searchGoods(this.searchData);
      // const query ={ keyword: this.searchData,categoryId: this.$route.query.categoryId,page: 1,size: 10 };
      const query ={ keyword: this.searchData, page: 1, size: 10 };
      this.$router.push({ path: `/PC/search`, query:query
      });
      // this.$router.push({path: 'PC/search?keyword=${this.searchData}&page=1&size=10', query: this.searchData});
      if(this.$store.state.userInfo != null){
        this.getHistory();
      }
    },
    clear(){
      this.searchData = '';
      const query ={ keyword: '',categoryId: 0, page: 1, size: 10 };
      this.$router.push({ path: `/PC/search`, query:query});
    },
    querySearch(queryString, cb) {
      let restaurants = this.restaurants;
      let results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        // 根据关键词生成正则表达式
        let patt = new RegExp(queryString.toLowerCase());
        // console.log (patt);
        // console.log (queryString.toLowerCase());
        // 过滤返回出符合结果的数据
        return patt.test(restaurant.value.toLowerCase());
      };
    },
    handleSelect(item) {
      this.search();
    },
  },
  mounted() {
    if(this.$store.state.userInfo != null){
        this.getHistory();
    }
  },
  created(){
    getCartInfo().then((response) => {
        if(response.errno == 501){
          this.$message({
            showClose: true,
            message: '尊敬的用户，请您先完成登录!',
            type: 'info',
          });
          this.$router.push('/PC/login?isLogin=true');
        }else{
          this.cartTotal_ = response.data.cartTotal.goodsCount
          // this.$store.state.userInfo.carts.goodsCount = response.data.cartTotal.goodsCount
          // localStorage.setItem('users', JSON.stringify(this.$store.state));
          this.$store.commit('setCartNum', this.cartTotal_)
          // this.$emit('sendMsg', cartTotalServer); //通知父组件改变
        }
      });
  }
};
</script>

<style scoped>
#app {
  background-color: #fff;
  height: 140px;
  box-shadow: 0 4px 4px #ccc;
}

.content {
  width: 1200px;
  height: 100%;
  margin: 0 auto;
}

.row {
  height: 100%;
}

.searchList {
  position: relative;
  top: 38px;
}

.searchList .el-link {
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/views/PC/search/Search.vue